import { Carousel, Container } from '@peracto/peracto-blocks-tailwind'

import ImagesCarousel from "./ImagesCarousel";
import BenchProducts from "./BenchProducts";
import FAQs from './FAQs'
import ImageCardsBlock from './ImageCardsBlock'

export default {
  plugins: {
    content: [Carousel, ImagesCarousel, BenchProducts, FAQs, ImageCardsBlock],
    layout: [Container],
  },
};
